<template>
  <v-row no-gutters>
    <v-col cols="12" v-if="show_options">
      <v-row no-gutters class="pa-4">
        <v-col cols="12" class="mb-6"> Select Performance metrics to proceed further</v-col>
        <v-col cols="12">
          <v-card flat class="mx-auto">
            <v-container class="pa-0">
              <v-item-group v-model="selected" multiple>
                <v-row no-gutters class="ma-2">
                  <v-col v-for="(item, i) in config.sections" :key="i" cols="6" md="4">
                    <v-item class="ma-4" v-slot="{ active, toggle }">
                      <v-card
                        :color="active ? 'primary' : 'primaryGrey'"
                        class="d-flex align-center ma-4"
                        dark
                        height="80"
                        @click="toggle"
                      >
                        <v-row no-gutters>
                          <v-col cols="10"
                            ><v-card-subtitle class="backgroundWhite--text">{{ item.label }}</v-card-subtitle>
                          </v-col>
                          <v-col cols="2"
                            ><v-icon right>
                              {{ item.icon }}
                            </v-icon></v-col
                          >
                        </v-row>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-container>
            <v-card-actions v-if="!under_develop" class="mt-6 float-right">
              <v-btn dense @click="showCharts()">Next </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" v-if="!show_options">
      <v-btn class="mb-3" color="backgroundWhite" dense depressed @click="showCharts()">
        <v-icon left> mdi-arrow-left </v-icon>
        Back</v-btn
      >
      <div class="my-4">
        <div class="primary--text text-subtitle-2 px-4">
          {{ config.chart.label }}
        </div>
        <LineChart v-if="chartData" :data="chartData" :chartData="config.chart" :from_min="from_min" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/assets.js";
import { content as reports_config } from "../../config/scavenger_reports.js";
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import LineChart from "../components/LineChart.vue";

export default {
  name: "ScavengerCustomizeReport",
  components: {
    LineChart,
  },
  props: ["device_id"],
  watch: {},
  data: function () {
    return {
      under_develop: true,
      page_content: null,
      show_options: true,
      selected: [],
      from_min: true,
      chart_data: null,
      items: [
        {
          src: "backgrounds/bg.jpg",
          label: "Interruptions",
        },
        {
          src: "backgrounds/md.jpg",
          label: "Voltage Sag",
        },
        {
          src: "backgrounds/bg-2.jpg",
          label: "Voltage Swell",
        },
        {
          src: "backgrounds/md2.jpg",
          label: "Frequency Variation",
        },
      ],
    };
  },
  created() {
    this.page_content = content;
    this.config = reports_config;
  },
  mounted() {
    this.get_scavenger_voltage();
  },
  filters: {},
  methods: {
    showCharts: function () {
      this.show_options = !this.show_options;
    },
    async get_scavenger_voltage() {
      this.network_error = false;
      const response = await axios_get(scv.get_scavenger_voltage_data, { id: this.device_id });
      this.chart_data = response;
    },
  },
  computed: {
    chartData: function () {
      var L1 = [];
      var L2 = [];
      var L3 = [];
      this.chart_data &&
        this.chart_data.map((e) => {
          L1.push({
            key: new Date(e.L1_vRms.key),
            value: e.L1_vRms.value,
          });
          L2.push({
            key: new Date(e.L2_vRms.key),
            value: e.L2_vRms.value,
          });
          L3.push({
            key: new Date(e.L3_vRms.key),
            value: e.L3_vRms.value,
          });
        });

      var data =
        L1.length > 0 && L2.length > 0 && L3.length > 0
          ? [
              {
                id: "L1_RMSVoltageMean",
                label: "L1_RMSVoltageMean",
                type: "line",
                values: L1.map((e) => e),
              },
              {
                id: "L2_RMSVoltageMean",
                label: "L2_RMSVoltageMean",
                type: "line",
                values: L2.map((e) => e),
              },
              {
                id: "L3_RMSVoltageMean",
                label: "L3_RMSVoltageMean",
                type: "line",
                values: L3.map((e) => e),
              },
            ]
          : null;
      return data;
    },
  },
};
</script>
